declare var require: any;
const locale = require('element-ui/lib/locale/lang/en');
const en = {
    ...locale.default,

    "home": "Home",
    "browse": "Search",
    "visualization": "Visualization",
    "tools": "Tool",
    "help": "Help",
    "view": "View",
    "multipleOmics": "Multiple Omics",
    "dataStatistics": "Data Statistics",
    "species": "Specie",
    "disease": "Disease",
    "sequencingType": "Sequencing Type",
    "sample": "Sample",
    "cellTissueType": "Cell Type",
    "ds": "Dataset",
    "print": "Publication",
    "cellNumber": "Cell Number",
    "dataset": "DataSet",
    "dataAnalyze": "Data Analyze",
    "visual": "Visual",
    "exploreTool": "Explore Tool",
    "tissue": "Tissue",
    "libraryPreparationProtocol": "Library Preparation Protocol",
    "pval": "P_val",
    "avgLog2fc": "Avg_log2FC",
    "pct1": "Pct.1",
    "pct2": "Pct.2",
    "pvalAdj": "P_val_adj",
    "cellType": "Cell Type",
    "gene": "Gene",
    "cellBrowser": "Cell browser",
    "geneBrowser": "Gene browser",
    "circleMap": "Circos plot",
    "volcanoMap": "Volcano plot",
    "spatialTranscriptomeBrowser": "ST browser",
    "apply": "Apply",
    "tissueType": "Tissue Type",
    "diseases": "Diseases",
    "samples": "Samples",
    "publications": "Publications",
    "cellNumbers": "Cell Numbers",
    "cellTypes": "Cell Types",
    "tissueTypes": "Tissue Types",
    "differentiallyExpressedGenes": "Differentially Expressed Genes",
    "datasetId": "Dataset Id",
    "projectId": "Project Id",
    "libraryProtocol": "Library Protocol",
    "cluster": "Cluster",
    "chrom": "Chromsome",

    "health": "Browse Health Data",
    "respiratoryDisease": "Browse Disease Data",
    "respiratorySystemCancer": "Respiratory system cancer",
    "lowerRespiratoryIllnessess": "Lower respiratory tract disease",
    "respiratoryInfectiousDisease": "Respiratory tract infectious disease",
    "lungCancer": "Lung cancer",
    "smallCell": "Small cell lung cancer",
    "Non-smallLung": "Non-small cell lung cancer",
    "Non-smallAdenocarcinoma": "Non-small cell lung adenocarcinoma",
    "Non-smallCell": "Non-small cell squamous lung carcinoma",
    "bronchialDisease": "Bronchial disease",
    "asthma": "Asthma",
    "lungDisease": "Lung disease",
    "interstitialLungDisease": "Interstitial lung disease",
    "pulmonaryFibrosis": "Pulmonary fibrosis",
    "ipf": "Idiopathic pulmonary fibrosis ",
    "extrinsicAllergicAlveolitis": "Extrinsic allergic alveolitis",
    "chronicObstructivePneumonia": "Chronic obstructive pulmonary disease",
    "cysticFibrosis": "Cystic fibrosis",
    "viralRespiratory": "Viral respiratory tract infection",
    "grippe": "Influenza",
    "COVID19": "COVID-19",
    "cytomegalovirusInfection": "Cytomegalovirus infection",
    "tuberculosis": "Tuberculosis",
    "bacterialPneumonia": "Bacterial pneumonia",
    "klebsiellaPneumonia": "Klebsiella pneumonia",
    "ventilatorAssociatedPneumonia": "Ventilator associated pneumonia",
    "hylacticPneumonia": "Hylactic Pneumonia",
    "pulmonaryTuberculosis": "pulmonary tuberculosis",
    "pulmonaryFibrosis  ": "Pulmonary Fibrosis",
    "other": "Other",
    "senility": "Aging",
    "smoke": "Smoke exposure",
    "transcriptomics" : "Transcriptomics",
    "genomics": "Genomics",
    "immunomics": "Immunomics",
    "spatialTranscriptomics": "Spatial Transcriptomics",
    "epigenomics": "Epigenomics",
    "multimodal": "Single-cell Multimodal",
    "singleCellRNASeqDesc": "The single cell transcriptome module contains gene expression differences between different diseases, tissues and cell types, and can be used to identify markers of disease and cell type .",
    "RNASeqDesc": "The transcriptome module contains differentially expressed genes between different treatment factors and can be used to identify markers related to respiratory disease and non-disease states, different tissues or cell types. ",
    "singleCellATACSeqDesc": "The single cell epigenomics contains Assay for Transposase-Accessible Chromatin using sequencing(ATAC-seq) which can detect chromatin accessibility in single cell.The module generates a gene activity matrix from the chromatin accessibility of the promoter regions of genes, containing differences in active genes across cell types.",
    "ATACSeqDesc": "The epigenomics contains genomic annotation information of genome-wide chromatin accessibility  to investigate the regulation of gene expression under different treatment factors",
    "singleCellTCRSeqDesc": "The single-cell TCR module identification and assembly of full-length rearranged V(D)J T-cell receptor sequences from paired-end single-cell RNA sequencing reads.It can be used to estimate the diversity of the immune system and to explore the relationship between the immunome repertoire and disease. ",
    "TCRSeqDesc": "The T cell surface receptor (TCR) has a VDJ gene rearrangement, which determines the immune diversity of the TCR and plays a key role in antigen recognition.The TCR-seq module data contains annotated information on the VDJ clonotypes of different diseases and tissues",
    "CITESeqDesc": "The single-cell multimodal module contains CITE-seq data, allowing simultaneous epitope and transcriptome measurement in single cells. Using amplified cDNA and antibody-derived tags (ADTs), we can investigate differences in gene expression and surface protein abundance across different cell types from different diseases and tissues.",
    "spatialTranscripomics": "Spatial transcriptome module simultaneously captures tissue spatial location and expression at the cellular or subcellular level",
    "GWASDesc": "GWAS data integrates many GWAS summary statistics and identifies credible sets of causal variants by uniformly processed fine-mapping.",
    "traits": "traits",
    "mesh": "MESH TERMS",
    "SNP": "SNPs",

    "jobSuccess": "Run Successfully",
    "emailSuccess": " Email Sent Successfully",
    "jobError": "Run Error",
    "datacenter": "Data Center",
    "dataerror": "Data does not exist!",
    "downerror": "Error generating download link:",
}

export default en;
